import type { Media } from '@/payload-types'

/**
 * Returns a size-variant URL suitable for `<video poster={…}>`.
 *
 * `<video poster>` is fetched eagerly by the browser as a plain URL — we
 * can't route it through `next/image` or the variant loader. Using the
 * top-level `resource.url` means the browser downloads the full-size
 * original (up to 2500px wide, multi-MB per hero load). Instead, pick the
 * first available pre-baked size variant in a sensible ladder and fall
 * back to the original only if no variants exist.
 */
export function getPosterUrl(
  resource: Media | string | null | undefined,
): string | undefined {
  if (!resource || typeof resource !== 'object') return undefined

  const sizes = resource.sizes

  return (
    sizes?.large?.url ??
    sizes?.xlarge?.url ??
    sizes?.medium?.url ??
    sizes?.small?.url ??
    sizes?.thumbnail?.url ??
    resource.url ??
    undefined
  ) as string | undefined
}
